import React, { FunctionComponent } from 'react';
import { Grid, Typography } from '@mui/material';
import InterventionsSideNav from './InterventionsSideNav/InterventionsSideNav';
import styles from './CalculatorInterventions.styles';
import useStyles from './CalculatorInterventions.styles';

const CalculatorInterventions: FunctionComponent = ({ children }) => {
  const classes = useStyles();
  const testid = 'interventions';

  return (
    <div className={classes.container}>
      <Grid container spacing={4} columnSpacing={0.25}>
        <Grid size={{xs:12}}>
          <Typography
            variant="h1"
            className={ classes.title }
            data-testid={`${testid}__title`}
          >
            HealthySteps Cost Savings Interventions
          </Typography>
        </Grid>
        <Grid size={{xs:4}} className={classes.sideNav}>
          <InterventionsSideNav />
        </Grid>
        <Grid size={{xs:8}} className={classes.main}>
          {children}
        </Grid>
      </Grid>
    </div>
  );
};

export default CalculatorInterventions;
